import React from 'react';
import Summoner from './Summoner.js'
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';

import "./Main.css"

export default class Main extends React.Component{
  render(){
    return(
      <div className = "mainPage">
        <Container fixed>
        <div className="championSearch">
          <img src="https://raw.communitydragon.org/7.23/plugins/rcp-fe-lol-champion-mastery-notifications/global/default/assets/cm_rank_up/7.png" alt= "Mastery7" id="Mastery7" width="132" height="118.5"></img>
          <h1>Mastery Race</h1>
          <Summoner />
        </div>
        </Container>
        <Container>
        <div className = "description">
        <img src={process.env.PUBLIC_URL + 'pic.png'} alt= "descriptionpic" id="descriptionpic" width="150" height="150"></img>
          <Typography variant="subtitle1"component="span">
          <Box fontWeight={550} m={1}>
            Compare champion masteries with your friends!
          </Box>
          </Typography>
          <Typography variant="body2"component="p">
            This project was developed on patch 10.16.1. Some features are no longer working as intended.
          </Typography>
        </div>
        </Container>
      </div>
    )
  }
}